// import React, { useEffect, useState } from 'react';
// import { Page, Button } from 'shared';
// import { routePaths } from 'services/routing';
// import { Redirect } from 'react-router-dom';
// import './ehr.scss';
// import { getSubscription, SubsriptionType } from 'preferences/billing/Subscription';
// import { useSelector } from 'react-redux';
// import { getIsOrgMember, getSSN, getIdentity, getIsIAL2Verified } from 'identity/selectors';
// import IdMeVerificationErrorModal from './IdMeVerificationErrorModal';
// import MedicalDataTable from './MedicalDataTable';
// import { isMobile, openRouteInApp, isIOS } from 'mobile/helpers';
// import HealthNavigationNew from './HealthNavigationNew';
// const env = window.env || {};


// export default function EHR(props) {
//   const [redirect, setRedirect] = useState(false);
//   const [isConfirmOpen, setIsConfirmOpen] = useState(false);
//   const [email, setEmail] = useState(null);
//   const currentSubscription = getSubscription();
//   const identity = useSelector(getIdentity);
//   const ssn = useSelector(getSSN);
//   const isIAL2Verified = useSelector(getIsIAL2Verified);
//   const isOrgMember = useSelector(getIsOrgMember);
//   //const isIdMeAuth = localStorage.getItem('isIdMeAuth') === 'true';
//   const isFreetire = currentSubscription.type == SubsriptionType.Free;

//   function doPayment() {
//     setRedirect(true);
//   }

//   function closeConfirm() {
//     setIsConfirmOpen(!isConfirmOpen);
//   }

//   function verifyIAL2() {
//     localStorage.setItem('IAL2Verification', true);
//     if (isMobile && isIOS) {
//       // skip
//       var iosRedirect = false;
//     }
//     else {
//       if (window.location.search) {
//         localStorage.setItem('IAL2VerificationRedirect', window.location.href.replace(window.location.search, ''));
//       } else {
//         localStorage.setItem('IAL2VerificationRedirect', window.location.href);
//       }
//     }

//     if (isMobile && !isIOS) {
//       openRouteInApp(env.Idme_verificationurl);
//     }
//     else {
//       window.location.href = env.Idme_verificationurl;
//     }
//     //'https://api.idmelabs.com/oauth/authorize?client_id=b88a4c79755cbc8509cd63c777179291&redirect_uri=https://dev-owen.myhc.app/&response_type=code&scope=openid%20http://idmanagement.gov/ns/assurance/ial/2/aal/2';
//   }

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const error = urlParams.get('error');
//     if (error && error.includes('access_denied')) {
//       setIsConfirmOpen(true);
//     }
//     if (identity) {
//       setEmail(identity.email);
//     }
//   }, []);
//   console.log('isFreetire', isFreetire, 'isIAL2Verified', isIAL2Verified, 'isOrgMember', isOrgMember);
//   return (
//     <Page
//       id='invoice-list'
//       backPath={{ to: props.location?.state?.backpath ?? routePaths.root }}
//       centerElement='Electronic Health Records'>
//       <div className="menu_container">
//         {isFreetire && !isOrgMember ? (
//           <div>
//             <div>
//               Upgrade your subscription to access your electronic health records from your hospitals and healthcare providers!
//             </div>
//             <div className='form-row claim-offer-btn upgrade-button'>
//               <Button id='subscribe-button' className="button blue btn btn-primary" onClick={doPayment}>Upgrade</Button>
//             </div>
//           </div>
//         ) : null}
//         {(!isFreetire || isOrgMember) && !isIAL2Verified ? (
//           <div className='verify-container'>
//             <div>
//               To ensure that your health data and privacy are fully protected and secure, we must verify your identity to NIST-IAL2 standards, which will require contact information, a government-issued photo ID and a smart phone. We use ID.me to conduct this easy, but necessary process.
//             </div>
//             <div className='form-row claim-offer-btn upgrade-button' style={{ cursor: 'pointer' }}>
//               <img onClick={verifyIAL2} height={45} src="/static/images/verifyidme.svg" alt="android iphone verifyidme" />
//             </div>
//           </div>
//         ) : null}

//         {(!isFreetire || isOrgMember) && isIAL2Verified ? <div className='menuBars'><HealthNavigationNew ssn={ssn} email={email} /></div> : null}
//         {isConfirmOpen ? <IdMeVerificationErrorModal isConfirmOpen={isConfirmOpen} closeConfirm={closeConfirm} /> : null}
//       </div>
//       {redirect ? <Redirect to='/view-plan' /> : null}
//     </Page>
//   );
// }


// import React, { useEffect, useState } from 'react';
// import { Page, Button } from 'shared';
// import { routePaths } from 'services/routing';
// import { Redirect } from 'react-router-dom';
// import './ehr.scss';
// import { getSubscription, SubsriptionType } from 'preferences/billing/Subscription';
// import { useSelector } from 'react-redux';
// import { getIsOrgMember, getIdentity, getIsIAL2Verified } from 'identity/selectors';
// import HealthNavigationNew from './HealthNavigationNew';
// import { epicDocuments, epicLogin, epicRefreshToken, epicToken } from 'app/config';

// export default function EHR(props) {

//   const [redirect, setRedirect] = useState(false);
//   const [isEpicConnected, setIsEpicConnected] = useState(false);
//   const [loadingEpic, setLoadingEpic] = useState(true);

//   const currentSubscription = getSubscription();
//   const identity = useSelector(getIdentity);
//   const isIAL2Verified = useSelector(getIsIAL2Verified);
//   const isOrgMember = useSelector(getIsOrgMember);

//   const isFreetire = currentSubscription.type === SubsriptionType.Free;

//   const epicLoginUrl = epicLogin;
//   const epicTokenApi = epicToken;
//   const epicDocumentsApi = epicDocuments;
//   const refreshTokenApi = epicRefreshToken;

//   function connectEpic() {
//     console.log("Redirecting user to Epic login");
//     window.location.href = epicLoginUrl;
//   }

//   const clearTokens = () => {

//     console.warn("Clearing stored Epic tokens");

//     localStorage.removeItem("epicAccessToken");
//     localStorage.removeItem("epicRefreshToken");
//     localStorage.removeItem("epicPatientId");
//     localStorage.removeItem("epicOidcToken");
//     localStorage.removeItem("epicEndpoint");

//   };

//   const refreshEpicToken = async () => {

//     try {

//       console.log("Attempting refresh token");

//       const refreshToken = localStorage.getItem("epicRefreshToken");

//       if (!refreshToken) {
//         console.log("No refresh token found");
//         return false;
//       }

//       const url = `${refreshTokenApi}&refreshToken=${refreshToken}`;

//       console.log("Refresh API:", url);

//       const res = await fetch(url);

//       console.log("Refresh response status:", res.status);

//       if (!res.ok) throw new Error("Refresh token failed");

//       const data = await res.json();

//       console.log("New token received:", data);

//       localStorage.setItem("epicAccessToken", data.accessToken);
//       localStorage.setItem("epicRefreshToken", data.refreshToken);

//       return true;

//     } catch (error) {

//       console.error("Refresh token failed:", error);

//       clearTokens();

//       return false;

//     }

//   };

//   const getEpicDocuments = async () => {

//     try {

//       console.log("Calling EpicDocuments API");

//       const accessToken = localStorage.getItem("epicAccessToken");
//       const patientId = localStorage.getItem("epicPatientId");
//       const oidcToken = localStorage.getItem("epicOidcToken");
//       const endpoint = localStorage.getItem("epicEndpoint");

//       const url =
//         `${epicDocumentsApi}` +
//         `&patientId=${patientId}` +
//         `&oidcToken=${oidcToken}` +
//         `&endpoint=${endpoint}` +
//         `&accessToken=${accessToken}`;

//       console.log("REQUEST:", url);

//       const res = await fetch(url);

//       console.log("Document API status:", res.status);

//       if (res.status === 401) {

//         console.warn("Access token expired → refreshing");

//         const success = await refreshEpicToken();

//         if (!success) {
//           setIsEpicConnected(false);
//           return;
//         }

//         const newAccessToken = localStorage.getItem("epicAccessToken");

//         const retryUrl =
//           `${epicDocumentsApi}` +
//           `&patientId=${patientId}` +
//           `&oidcToken=${oidcToken}` +
//           `&endpoint=${endpoint}` +
//           `&accessToken=${newAccessToken}`;

//         console.log("Retrying Document API");

//         const retry = await fetch(retryUrl);

//         const retryData = await retry.json();

//         console.log("Documents fetched:", retryData);

//         return retryData;

//       }

//       const data = await res.json();

//       console.log("Documents fetched:", data);

//       return data;

//     } catch (error) {

//       console.error("Document API error:", error);

//     }

//   };

//   useEffect(() => {

//     const initEpicConnection = async () => {

//       console.log("Checking OAuth callback");

//       const params = new URLSearchParams(window.location.search);
//       const code = params.get("code");

//       if (code) {

//         console.log("OAuth code received:", code);

//         const callbackUrl = `${epicTokenApi}?code=${code}`;

//         try {

//           const res = await fetch(callbackUrl);

//           console.log("Callback API status:", res.status);

//           const data = await res.json();

//           console.log("Callback response:", data);

//           if (data.accessToken && data.patientId) {

//             localStorage.setItem("epicAccessToken", data.accessToken);
//             localStorage.setItem("epicRefreshToken", data.refreshToken);
//             localStorage.setItem("epicPatientId", data.patientId);
//             localStorage.setItem("epicOidcToken", data.oidcToken);
//             localStorage.setItem("epicEndpoint", data.endpoint);

//             setIsEpicConnected(true);

//             props.history.replace("/electronic-health-records");

//           }

//         } catch (err) {

//           console.error("Callback API error:", err);

//         }

//       } else {

//         console.log("Checking stored refresh token");

//         const success = await refreshEpicToken();

//         if (success) {
//           console.log("Refresh success → Epic connected");
//           setIsEpicConnected(true);
//         } else {
//           console.log("Refresh failed → show connect card");
//           setIsEpicConnected(false);
//         }

//       }

//       setLoadingEpic(false);

//       if (identity) {
//         setEmail(identity.email);
//       }

//     };

//     initEpicConnection();

//   }, []);

//   return (

//     <Page
//       id='invoice-list'
//       backPath={{ to: props.location?.state?.backpath ?? routePaths.root }}
//       centerElement='Electronic Health Records'
//     >

//       <div className="menu_container">

//         {(!isFreetire || isOrgMember) && isIAL2Verified && !isEpicConnected && !loadingEpic && (

//           <div className="epic-connect-card">

//             <div className='epic-inner-card'>

//               <h3>Connect Your Epic Health Records</h3>

//               <p>
//                 Connect your Epic account to securely access your medical records from hospitals and healthcare providers.
//               </p>

//               <Button className="button blue" onClick={connectEpic}>
//                 Connect with Epic
//               </Button>

//             </div>

//           </div>

//         )}

//         {loadingEpic && (
//           <div style={{ padding: "20px" }}>
//             Checking Epic connection...
//           </div>
//         )}

//         {isEpicConnected && !loadingEpic && (

//           <div className='menuBars'>

//             <HealthNavigationNew
//               fetchDocuments={getEpicDocuments}
//             />

//           </div>

//         )}

//       </div>

//       {redirect && <Redirect to='/view-plan' />}

//     </Page>

//   );
// }


import React, { useEffect, useState } from 'react';
import { Page, Button } from 'shared';
import { routePaths } from 'services/routing';
import { Redirect } from 'react-router-dom';
import './ehr.scss';

import { getSubscription, SubsriptionType } from 'preferences/billing/Subscription';
import { useSelector } from 'react-redux';
import { getIsOrgMember, getIdentity, getIsIAL2Verified } from 'identity/selectors';

import IdMeVerificationErrorModal from './IdMeVerificationErrorModal';
import { isMobile, openRouteInApp, isIOS } from 'mobile/helpers';
import HealthNavigationNew from './HealthNavigationNew';

import { epicLogin } from 'app/config';

const env = window.env || {};

export default function EHR(props) {

  const [redirect, setRedirect] = useState(false);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isEpicConnected, setIsEpicConnected] = useState(false);
  const [loadingEpic, setLoadingEpic] = useState(true);

  const currentSubscription = getSubscription();
  const identity = useSelector(getIdentity);
  const isIAL2Verified = useSelector(getIsIAL2Verified);
  const isOrgMember = useSelector(getIsOrgMember);

  const isFreetire = currentSubscription.type === SubsriptionType.Free;


  const doPayment = () => {
    setRedirect(true);
  };


  const closeConfirm = () => {
    setIsConfirmOpen(!isConfirmOpen);
  };

  const verifyIAL2 = () => {

    localStorage.setItem('IAL2Verification', true);

    if (!(isMobile && isIOS)) {
      const redirectUrl = window.location.search
        ? window.location.href.replace(window.location.search, '')
        : window.location.href;

      localStorage.setItem('IAL2VerificationRedirect', redirectUrl);
    }

    if (isMobile && !isIOS) {
      openRouteInApp(env.Idme_verificationurl);
    } else {
      window.location.href = env.Idme_verificationurl;
    }
  };


  const connectEpic = () => {
    window.location.href = `${epicLogin}&state=epic`;
  };

  const checkEpicConnection = () => {

    const token = localStorage.getItem("epicAccessToken");
    const patient = localStorage.getItem("epicPatientId");

    console.log("Epic check:", token, patient);

    if (token && patient) {
      setIsEpicConnected(true);
    } else {
      setIsEpicConnected(false);
    }

    setLoadingEpic(false);
  };


  useEffect(() => {

    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');

    if (error && error.includes('access_denied')) {
      setIsConfirmOpen(true);
    }

    checkEpicConnection();

  }, []);

  console.log('isFreetire', isFreetire, 'isIAL2Verified', isIAL2Verified, 'isOrgMember', isOrgMember);


  return (
    <Page
      id='invoice-list'
      backPath={{ to: props.location?.state?.backpath ?? routePaths.root }}
      centerElement='Electronic Health Records'
    >

      <div className="menu_container">


        {isFreetire && !isOrgMember && (
          <div>
            <div>
              Upgrade your subscription to access your electronic health records.
            </div>
            <div className='form-row claim-offer-btn upgrade-button'>
              <Button className="button blue btn btn-primary" onClick={doPayment}>
                Upgrade
              </Button>
            </div>
          </div>
        )}

        {(!isFreetire || isOrgMember) && !isIAL2Verified && (
          <div className='verify-container'>
            <div>
              To ensure your health data is secure, verify your identity (NIST-IAL2).
            </div>
            <div className='form-row claim-offer-btn upgrade-button' style={{ cursor: 'pointer' }}>
              <img
                onClick={verifyIAL2}
                height={45}
                src="/static/images/verifyidme.svg"
                alt="verify idme"
              />
            </div>
          </div>
        )}

        {(!isFreetire || isOrgMember) &&
          isIAL2Verified &&
          !loadingEpic &&
          !isEpicConnected && (

            <div className="epic-connect-card">
              <div className="epic-inner-card">

                <h3>Connect Your MyChart Account</h3>

                <p>
                  Securely link your hospital records via MyChart for seamless and reliable access.
                </p>

                <Button className="button blue" onClick={connectEpic}>
                  Connect with MyChart
                </Button>

              </div>
            </div>
          )}

        {loadingEpic && (
          <div style={{ padding: "20px" }}>
            Checking Epic connection...
          </div>
        )}


        {(!isFreetire || isOrgMember) &&
          isIAL2Verified &&
          isEpicConnected &&
          !loadingEpic && (

            <div className='menuBars'>
              <HealthNavigationNew />
            </div>
          )}

        {isConfirmOpen && (
          <IdMeVerificationErrorModal
            isConfirmOpen={isConfirmOpen}
            closeConfirm={closeConfirm}
          />
        )}

      </div>

      {redirect && <Redirect to='/view-plan' />}

    </Page>
  );
}
